import {ActionTree} from 'vuex'
import Gallery from '@/modules/cms/modules/gallery/model/Gallery'
import {GalleryState} from '@/modules/cms/modules/gallery/store/index'
import {RootState} from '@/store/types'
import {MutationTypes} from '@/modules/cms/modules/gallery/store/mutations'
import * as api from '@/modules/cms/modules/gallery/api'
import {MediaObject} from '@/modules/media/types';
import GalleryItem from '@/modules/cms/modules/gallery/model/GalleryItem'

export interface GalleryItemDescriptor {
    media: MediaObject
}

const actions: ActionTree<GalleryState, RootState> = {
    /**
     * Carga la lista de galerías registradas en la aplicación
     *
     * @param state
     * @param commit
     * @param force
     */
    async loadGalleryList ({state, commit}, force?: boolean) {
        if (state.galleryListFetched && !force) {
            return
        }

        commit(MutationTypes.SetGalleryList, await api.getGalleryList())
        commit(MutationTypes.ToggleGalleryListFetched, true)
    },

    /**
     * Carga una galería en el estado de la aplicación
     */
    async loadGallery ({commit}, id: number) {
        commit(MutationTypes.SetCurrentGallery, await api.getGallery(id))
    },

    /**
     * Crea un nuevo elemento y lo inserta en la galería actual
     *
     * @param commit
     * @param payload
     */
    async createGalleryItem ({commit}, payload: GalleryItemDescriptor | GalleryItemDescriptor[]) {
        if (!Array.isArray(payload)) {
            payload = [payload]
        }

        payload.forEach(d => {
            commit(MutationTypes.AddGalleryItem, new GalleryItem(0, d.media))
        })
    },

    /**
     * Guarda la galería actual
     */
    async saveGallery ({state, commit}) {
        let gallery = state.currentGallery
        gallery = gallery.isNew
            ? await api.createGallery(gallery)
            : await api.updateGallery(gallery)

        commit(MutationTypes.SetCurrentGallery, gallery)
        // Resetea el elemento actual
        commit(MutationTypes.SetCurrentGalleryItem, new GalleryItem())
        commit(MutationTypes.AddGallery, gallery)
    },

    /**
     * Carga una nueva galería
     */
    async loadNewGallery ({commit}) {
        commit(MutationTypes.SetCurrentGallery, new Gallery())
        commit(MutationTypes.SetCurrentGalleryItem, new GalleryItem())
    },

    /**
     * Elimina un galería
     *
     * @param context
     * @param gallery
     */
    async deleteGallery ({commit}, gallery: Gallery) {
        const id = gallery.id
        await api.deleteGallery(gallery)

        // Elimina la galería de la lista de galerías actualmente cargada en el estado
        commit(MutationTypes.DeleteGallery, id)
    },
}

export default actions
